import { IsNotEmpty } from "class-validator";
import { IsEmail } from "@wog/mol-lib-api-contract/utils/validators";
import { EMAIL_MAX_CHARS } from "app/common/email";

export class DeathCertDocumentEmailDO {
	@IsEmail({ maxLength: EMAIL_MAX_CHARS })
	@IsNotEmpty()
	public email!: string;
}
